import { ReactElement } from "react";

export function Card({
    children,
    customization,
}: {
    children: ReactElement;
    customization?: string | undefined;
}) {
    var cardClass = customization ?? "bg-gray-50 border-gray-200";

    return (
        <div className={cardClass + " p-2 rounded-md shadow-sm border "}>
            {children}
        </div>
    );
}
